import React from 'react';
import './styles.css';

interface HeaderProps {
  onNewRecipe: () => void;
  onViewHistory: () => void;
}

const Header: React.FC<HeaderProps> = ({ onNewRecipe, onViewHistory }) => {
  return (
    <header className="header-container">
      <h1 className="header-title">
        虚拟配方设计器
      </h1>
      <div className="header-button-group">
        <button 
          className="header-button header-button-primary"
          onClick={onNewRecipe}
        //   data-tooltip="创建新的配方设计"
        >
          <span className="header-button-icon">+</span>
          <span className="header-button-text">新建配方</span>
        </button>
        <button 
          className="header-button header-button-secondary"
          onClick={onViewHistory}
        //   data-tooltip="查看历史配方记录"
        >
          <span className="header-button-icon">📋</span>
          <span className="header-button-text">查看配方</span>
        </button>
      </div>
    </header>
  );
};

export default Header;